export default {"src":"/_next/static/media/family.2201f240.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};